import Vue from 'vue';
import Vuex from 'vuex';

import '@/assets/css/style.css';
import '@public/assets/vendor/bootstrap/css/bootstrap.min.css';
import '@public/assets/css/bootstrap.min.css';


// Modules
import app from './app';
import auth from './auth';
import sysadmin from './sysadmin';
import customers from './customer';
import maintenancejobs from './maintenancejobs';
import properties from './properties';
import contractors from './contractors';
import inspectors from './inspectors';




// Plugins
import vuexPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [vuexPersistedState({
    storage: window.sessionStorage,
		rehydrated: (store: any) => {
			store.commit('app/rehydrateState', null, { root: true });
			store.commit('auth/rehydrateState', null, { root: true });
			store.commit('sysadmin/rehydrateState', null, { root: true });
			store.commit('customers/rehydrateState', null, { root: true });
			store.commit('maintenancejobs/rehydrateState', null, { root: true });
      store.commit('properties/rehydrateState', null, { root: true });
      store.commit('contractors/rehydrateState', null, { root: true });
      store.commit('inspectors/rehydrateState', null, { root: true });

		},
    paths: ['app', 'auth', 'sysadmin', 'customers', 'maintenancejobs','properties','contractors','inspectors'],
  })],
  modules: {
    app,
    auth,
    sysadmin,
    customers,
		maintenancejobs,
    properties,
    contractors,
    inspectors
  },
});

export default store;
